import { isArray } from 'lodash';
import PropTypes from 'prop-types';

const HandleAPI = (err, alert, intl) => {
    if (err.response) {
        switch (err.response.status) {
            case 400:
                var errMessage = '';
                console.log(err.response);
                if (!!err.response?.data?.errors) {
                    const errors = err.response.data.errors
                    for (const e in errors) {
                        if (typeof errors[e] === 'string')
                            errMessage = errors[e];

                        else if (isArray(errors[e])) {
                            errors[e].forEach(y => errMessage = y);
                        }
                    }
                }
                if (!!errMessage && errMessage !== '')
                    alert.show(errMessage); 
                else
                    alert.show(intl.formatMessage({ id: 'badRequest', defaultMessage: 'Bad request' })); 
                break;

            case 401:
            case 403: alert.show(intl.formatMessage({ id: 'accessDenied', defaultMessage: 'Access denied' })); break;
            case 404: alert.show(intl.formatMessage({ id: 'notFound', defaultMessage: 'The requested resource is not available' })); break;
            default: alert.show(intl.formatMessage({ id: 'connectionProblem', defaultMessage: 'Connection problem' })); break;
        }

    } else if (err.request) {
        alert.error(intl.formatMessage({ id: 'requestError', defaultMessage: 'Request error' }));
        console.log(err.request);

    } else
        alert.error(intl.formatMessage({ id: 'connectionError', defaultMessage: 'Connection error' }));
}


HandleAPI.propTypes = {
    err : PropTypes.object.isRequired,
    alert: PropTypes.func.isRequired,
    intl : PropTypes.func.isRequired
}

export default HandleAPI
